import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-credit-note',
  templateUrl: './credit-note.component.html',
  styleUrls: ['./credit-note.component.scss']
})
export class CreditNoteComponent implements OnInit {

  displayColumns = ['slno', 'reference', 'description', 'amount', 'action'];
  credit_notes:any = [
    {
      reference: '',
      description:'',
      amount:0
    }
  ];
  narration = '';
  total_credit_note = 0;
  total = 0;
  bill_id;
  igst = 0;
  sgst = 0;
  transit_type =''
  showLoader = false;
  currencySymbol;
  reverse_charge;
  country;
  vat;
  gst;
  constructor(private dialog:MatDialogRef<CreditNoteComponent>,@Inject(MAT_DIALOG_DATA) public parentData:any,private http: HttpService,
  private snackbar: SnackbarService, private translate: TranslateService) { }

  ngOnInit() {
    this.getConstants();
    this.bill_id = this.parentData.bill_id;
    this.reverse_charge = this.parentData.reverse_charge
    this.transit_type = this.parentData.transit_type;
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.country = environment.country;
    if(this.country == 'IN'){
      if(!this.reverse_charge && this.parentData.invoice.tax_type == 'FCM12'){
        if(this.transit_type == 'INTRA'){
          this.gst = environment.FCM12_GST;
        }else{
          this.gst = environment.FCM12_GST;
        }
      } else if(!this.reverse_charge && this.parentData.invoice.tax_type == 'FCM18'){
        if(this.transit_type == 'INTRA'){
          this.gst = environment.FCM18_GST;
        }else{
          this.gst = environment.FCM18_GST;
        }
      } else if(this.reverse_charge){
        if(this.transit_type == 'INTRA'){
          this.gst = environment.RCM_GST;
        }else{
          this.gst = environment.RCM_GST;
        }
      }
    }else{
      this.gst = environment.FCM12_GST;
    }
  }

  getConstants() {
    this.showLoader = true;
    this.http.get('constants').subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          this.narration = (response.data.narration && response.data.narration.credit_note) ? response.data.narration.credit_note : '';
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message,'','err');
      }
    );
  }

  createCreditNote(){
    let cred_notes = this.credit_notes.map((note)=>{
      const temp: any = {
        value: note.amount,
        comment: note.description
      };
      (note.reference && note.reference.trim().length) ? temp.reference_id = note.reference : '';
      return temp;
    });

    for(let i = 0;i<this.credit_notes.length;i++){
      if(!this.credit_notes[i].description){
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.CREATE_CREDIT_NOTE.VALIDATION.DESCRIPTION'),'','err');
        return;
      }else if(!this.credit_notes[i].amount){
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.CREATE_CREDIT_NOTE.VALIDATION.AMOUNT'),'','err');
        return;
      }
    }

    const payload: any = {
      bill_id: this.parentData.id,
      type: 'Credit',
      line_items: cred_notes,
    };

    (this.narration && this.narration.trim().length) ? payload.narration = this.narration : '';

    this.showLoader = true;
    this.http.post('carrier_note/create',payload,1).subscribe((response:any)=>{
      if(response.statusCode == 200){
        this.showLoader = false;
        this.snackbar.openSnackBar(this.translate.instant('MESSAGE.CREATE_CREDIT_NOTE.SUCCESS.CREATE'));
        this.dialog.close(response);
      }
    },
    (err)=>{
      this.showLoader = false;
      this.snackbar.openSnackBar(err.error.message,'','err');
    });
  }

  deleteCreditNote(i){
    this.credit_notes.splice(i, 1);
    this.credit_notes = [...this.credit_notes];
  }

  addNewCreditNote(){
    this.credit_notes.push({
      description:'',
      amount:0
    });
    this.credit_notes = [...this.credit_notes];
  }

  calculateTotal(){
    this.total = this.credit_notes.reduce((summ, v) => (summ += (!v.amount) ? 0:parseInt(v.amount)), 0);
    return this.total.toFixed(2);
  }

  calculateIGST(){
    let gst = (this.gst / 100)
    this.igst = this.total * gst;
    return this.igst.toFixed(2);
  }

  calculateSGST(){
    let gst = (this.gst / 2) / 100;
    this.sgst = this.total * gst;
    return this.sgst.toFixed(2);
  }

  calculateVAT(){
    let gst = this.gst / 100
    this.vat = this.total * gst;
    return this.vat.toFixed(2);
  }

  calculateTotalCreditNote(){
    if(this.parentData.reverse_charge == 'Yes'){
      this.total_credit_note = this.total;
    }else{
      this.total_credit_note = this.total + (2 * this.sgst);
    }
    return this.total_credit_note.toFixed(2);
  }

  closeModal(){
    this.dialog.close();
  }

}
